module.exports = __webpack_public_path__ + "static/base-2-9e067d83cd0b572b9a3a466d15865ff0.jpg";